import { DateRangeControl } from '../../../../../constants/form-control/core/common/date-range/date-range';
import { textBoxControl } from '../../../../../constants/form-control/core/common/textbox/textbox';
import { clientSelectControl, locationSelectControl } from '../../../../../constants/form-control/employee/assign-location';
import { FormControlUtil } from '../../../../../core/utils/form-control';
import { MasterService } from '../../../../../state/master/services/master.service';

export const HANDOVER_NOTES_FILTER_CONTROL = {
  search: FormControlUtil.mergeFormControl(textBoxControl, {
    key: 'search',
    templateOptions: FormControlUtil.mergeFormControl(textBoxControl.templateOptions, {
      placeholder: 'Search',
    }),
  }),
  clientIds: FormControlUtil.mergeFormControl(clientSelectControl, {
    key: 'clientIds',
    templateOptions: FormControlUtil.mergeFormControl(clientSelectControl.templateOptions, {
      multiple: false,
      placeholder: 'All ' + MasterService.masterBusinessLabel.Client,
      selectOptions: {
      },
    }),
    validations: {
      validators: {
      },
      messages: {
      },
    },
  }),
  locationIds: FormControlUtil.mergeFormControl(locationSelectControl, {
    key: 'locationIds', templateOptions: FormControlUtil.mergeFormControl(locationSelectControl.templateOptions, {
      label: MasterService.masterBusinessLabel.Location,
      placeholder: 'All ' + MasterService.masterBusinessLabel.Location,
      bindLabel: 'location_name',
      multiple: false,
      bindValue: 'location_id',
      selectOptions: {
      },
    }),

    validations: {
      validators: {
      },
      messages: {
      },
    },
  }),
  dateRange: FormControlUtil.mergeFormControl(DateRangeControl, {
    key: 'date-range', templateOptions: FormControlUtil.mergeFormControl(DateRangeControl.templateOptions, {
      label: 'Added Date',
    }),
  }),
};

export const COMPLETED_HANDOVER_NOTES_FILTER_CONTROL = {
  clientIds: FormControlUtil.mergeFormControl(clientSelectControl, {
    key: 'clientIds',
    templateOptions: FormControlUtil.mergeFormControl(clientSelectControl.templateOptions, {
      multiple: false,
      placeholder: '',
      selectOptions: {
      },
    }),
    validations: {
      validators: {
      },
      messages: {
      },
    },
  }),
  locationIds: FormControlUtil.mergeFormControl(locationSelectControl, {
    key: 'locationIds', templateOptions: FormControlUtil.mergeFormControl(locationSelectControl.templateOptions, {
      label: 'Location',
      placeholder: '',
      bindLabel: 'location_name',
      multiple: false,
      bindValue: 'location_id',
      selectOptions: {
      },
    }),

    validations: {
      validators: {
      },
      messages: {
      },
    },
  }),
  dateRange: FormControlUtil.mergeFormControl(DateRangeControl, {
    key: 'date-range', templateOptions: FormControlUtil.mergeFormControl(DateRangeControl.templateOptions, {
      label: 'Added Date',
    }),
  }),
};
